module.exports = __webpack_public_path__ + "img/img44.2fe3ada0.svg";